export const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const mobileNumberReg = /^[6789]\d{9}$/;
export const pdfDocReg = /(\.jpeg|\.jpg|\.png| \.svg)$/i;
export const csvReg = /(\.csv)$/i;
export const number = /^[0-9]+$/;
export const percentageRegex = /^(?:100|\d{1,2})$/;
export const vehicleRegex = /^[a-zA-Z0-9]*$/;

export const imageSize = {
    fileSize : 1048576,
    fiveMb : 5120000
  }

const invalidChar = ["e", "E", "+", "-"];
export const blockInvalidChar = (e) => {
  if (e.which === 38 || e.which === 40) {
    e.preventDefault();
    return;
  }
  else {
    invalidChar.includes(e.key) && e.preventDefault();
  }
}
  

export const numberTill12Regex = (e) => {
  const fieldNames = ["nightEnd", "nightStart", "maxTime"];
  const inputValue = parseFloat(e.target.value + e.key || 0);
  const hourFormat = 24;

  if (e.which === 38 || e.which === 40) {
    e.preventDefault();
    return;
  }

  // Check if the input value is already at 12 and prevent further input
  if (!isNaN(inputValue) && inputValue > hourFormat ) {
    e.preventDefault();
    return;
  }

  if (invalidChar.includes(e.key) || e.key === ".") {
    e.preventDefault();
    return;
  }

  if (fieldNames.includes(e.target.name)) {
    // Check if the key is in the list of invalid characters or if the key is a decimal point
 
    // Prevent entering multiple leading zeroes
    if (inputValue === 0 && e.key === "0" && !e.target.value.includes("0")) {
      e.preventDefault();
      return;
    }
  }
};
